import { configureStore } from '@reduxjs/toolkit';
import dashboardSlice from './reducer/dashboardSlice';
import authSlice from './reducer/authSlice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    auth: authSlice,
  }
});
